import { Route, Routes } from "react-router-dom";
import { Shell } from "./components/Shell";
import { DiscoverPage } from "./pages/DiscoverPage";
import { LibraryPage } from "./pages/LibraryPage";
import { LegalPage } from "./pages/LegalPage";
import { ListsPage } from "./pages/ListsPage";
import { PeoplePage } from "./pages/PeoplePage";
import { ProfilePage } from "./pages/ProfilePage";
import { SearchPage } from "./pages/SearchPage";
import { SupportPage } from "./pages/SupportPage";

export function App() {
  return <Routes><Route element={<Shell />}><Route index element={<DiscoverPage />} /><Route path="search" element={<SearchPage />} /><Route path="library" element={<LibraryPage />} /><Route path="lists" element={<ListsPage />} /><Route path="people" element={<PeoplePage />} /><Route path="profile" element={<ProfilePage />} /><Route path="privacy" element={<LegalPage kind="privacy" />} /><Route path="terms" element={<LegalPage kind="terms" />} /><Route path="support" element={<SupportPage />} /><Route path="*" element={<DiscoverPage />} /></Route></Routes>;
}
